import { useEffect, useState } from 'react';
import ApiDatabase from 'server';

const quiet = (error) => {
  if (error?.name !== 'CanceledError') console.error(error);
};

/**
 * The choices of the real filters of the companies, read once: the
 * departments of their addresses, the Pennylane categories (which also name
 * the « Secteur » column) and the suppliers.
 */
const useCompanyFilterOptions = () => {
  const [departments, setDepartments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    ApiDatabase.getCityDepartments({}, (data) => setDepartments(Array.isArray(data) ? data : []), quiet);
    ApiDatabase.getPennyLaneCategories({}, (data) => setCategories(data?.items ?? []), quiet);
    ApiDatabase.getCompanySuppliers({}, (data) => setSuppliers(Array.isArray(data) ? data : []), quiet);
  }, []);

  return { departments, categories, suppliers };
};

export default useCompanyFilterOptions;
